module.exports = __webpack_public_path__ + "static/media/400022_02.84670892.png";